export default {"src":"/_next/static/media/phone-minor.df0fb1f4.svg","height":75,"width":66};